// actions.js
export const setUserAuthentication = (isAuthenticated) => ({
  type: "SET_USER_AUTHENTICATION",
  payload: isAuthenticated,
});
